import React from 'react'
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Errors from "../Errors/Errors"
import I18n from 'i18n-js'

export default class ForgotPassword extends React.Component {
  
  constructor(props) {
    super(props)
    
    this.state = {
      errors: [],
      success: null,
      loading: false,
      email: '',
      password: '',
    }

    this.onChange = this.onChange.bind(this)
    this.onDismissSuccess = this.onDismissSuccess.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  render() {

    return (
      <form onSubmit={this.onSubmit} style={{position: 'relative'}}>
        <Errors errors={this.state.errors} />
        {this.renderSuccess()}
        {/*<h1>{I18n.t('forgot_password')}</h1>*/}

        <div className="form-group">
          <label>{I18n.t('email')}</label>
          <input type="text" name="email" className="form-control" value={this.state.email} onChange={this.onChange} />
        </div>

        <div className="actions">
          <button type="submit" className="btn btn-primary">{I18n.t('send_me_reset_password_instructions')}</button>
        </div>

        <hr />

        <div><a href={this.props.sign_in_path}>{I18n.t('sign_in')}</a></div>

        <LoadingSpinner backgroundColor="rgba(32,33,46,0.5)" size="small" show={this.state.loading} />
      </form>
    )
  }

  renderSuccess() {
    if (this.state.success) {
      return (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {this.state.success}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label={I18n.t('close')} onClick={this.onDismissSuccess} style={{
            fontWeight: 'bold', fontSize: '21px', background: 'transparent', border: '0',
            position: 'absolute', right: '5px', top: '7px', color: '#777'}}>×</button>
        </div>
      )
    }
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  onDismissSuccess() {
    this.setState({success: null})
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: this.props.forgot_password_path,
      data: {
        email: this.state.email,
      }
    }).done((data) => {
      if (data.success) {
        this.setState({loading: false, errors: [], success: data.success})
      } else {
        this.setState({loading: false, errors: data.errors, success: null})
      }
    });
  }

};